export enum EngagementFlag {
    'Demo' = 1,
    'Live' = 2
}

export class EngagementFlagOption {
    id: number;
    value: string;
    constructor(_id: number, _value: string) {
        this.id = _id;
        this.value = _value;
    }
}

export class EngagementFlagOptions {
    options: EngagementFlagOption[] = [];
    constructor() {
        for (var key in EngagementFlag) {
            var engagementFlagId = Number(key);
            if (!isNaN(engagementFlagId)) {
                this.options.push(new EngagementFlagOption(engagementFlagId, EngagementFlag[engagementFlagId]));
            }
        }
    }
}
